import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useI18n } from "../context/I18nContext";

export default function Splash() {
  const { t } = useI18n();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const ti = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(ti);
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F4F4] grain text-black flex flex-col" data-testid="splash-page">
      <div className="w-full border-b-2 border-black bg-[#E00000] overflow-hidden">
        <div className="ticker flex whitespace-nowrap py-2 font-mono-civic text-white text-xs uppercase tracking-[0.3em]">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i} className="flex shrink-0">
              {Array.from({ length: 8 }).map((__, j) => (
                <span key={j} className="px-6 inline-flex items-center gap-3">
                  {t("splash_ticker")}
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>

      <div className="flex-1 flex flex-col items-start justify-center max-w-6xl mx-auto w-full px-6 sm:px-10 py-16">
        <div className={`transition-all duration-700 ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-[2px] bg-black" />
            <span className="font-mono-civic text-xs uppercase tracking-[0.4em] text-black">
              {t("splash_edition")}
            </span>
          </div>

          <h1 className="font-serif-display font-extrabold text-black leading-[0.85] tracking-tighter text-[18vw] sm:text-[14vw] md:text-[11vw] lg:text-[9rem]">
            Canadian
          </h1>
          <h1 className="font-serif-display italic font-bold text-black leading-[0.85] tracking-tighter text-[18vw] sm:text-[14vw] md:text-[11vw] lg:text-[9rem]">
            Opinions<span className="text-[#E00000]">.</span>
          </h1>

          <div className="mt-10 max-w-2xl">
            <p className="font-bold text-black text-base sm:text-lg leading-relaxed">
              {t("splash_lede")}
            </p>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Link
              to="/home"
              className="inline-flex items-center justify-center bg-black text-white font-bold uppercase tracking-widest px-8 py-5 border-2 border-black brutal-shadow hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all"
              data-testid="splash-enter-btn"
            >
              {t("splash_enter")}
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center justify-center bg-white text-black font-bold uppercase tracking-widest px-8 py-5 border-2 border-black hover:bg-black hover:text-white transition-colors"
              data-testid="splash-login-btn"
            >
              {t("splash_login_members")}
            </Link>
          </div>
        </div>
      </div>

      <footer className="border-t-2 border-black bg-[#F4F4F4]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between text-xs font-mono-civic uppercase tracking-widest text-black flex-wrap gap-2">
          <span>{t("splash_footer_left")}</span>
          <Link to="/legal" className="underline" data-testid="splash-legal-link">{t("splash_legal_link")}</Link>
        </div>
      </footer>
    </div>
  );
}
